import { useState } from "react";
import ModalAutoRenew from "../ModalAutoRenew/ModalAutoRenew";
import StudentCreditsManageTableRow from "./components/StudentCreditsManageTableRow";
import React from "react";
import { FiPlus } from "react-icons/fi";
import { Pagination } from "../../../components/shared/Pagination/Pagination";

const StudentCreditsManageTable = ({
  currentPage,
  handleAutoRenewal,
  handleUpgradeStudent,
  onPageChange,
  pageNumber,
  students,
  user,
}) => {
  const [selectedStudent, setSelectedStudent] = useState(null);
  const [initialModalStep, setInitialModalStep] = useState(null);
  const [isModalOpen, setModalOpen] = useState(false);

  const handleOpenModal = (student, step) => {
    setSelectedStudent(student);
    setInitialModalStep(step);
    setModalOpen(true);
  };

  const handleCloseModal = () => {
    setModalOpen(false);
    setSelectedStudent(null);
    setInitialModalStep(null);
  };

  return (
    <>
      {students?.length === 0 ? (
        <div className="flex flex-col items-center justify-center">
          <img
            className="mx-auto mt-10 w-1/2 max-w-[393px]"
            src="/images/student-credits/no-students.svg"
          />

          <div className="mt-4 text-center text-black font-bold text-lg">
            You don’t have any students yet
          </div>

          <div className="mt-4 text-center text-grayTrue700 text-sm">
            Invite your students to Sportsbox to start using your credits and
            record unlimited swings
          </div>

          {/* <button
            className="mt-4 w-fit min-h-11 h-11 rounded-full font-semibold text-sm btnPrimary500 flex flex-row items-center gap-2"
            onClick={() =>
              window.webkit.messageHandlers.iosListener.postMessage(
                "doSomething"
              )
            }
          >
            <FiPlus className="size-4 min-w-4" />
            Invite student
          </button> */}
        </div>
      ) : (
        <div className="overflow-x-auto text-left rounded-xl border border-gray200">
          <table className="border-none overflow-hidden border-collapse border-spacing-0 min-w-full">
            <thead>
              <tr className="bg-gray50 text-xs text-left text-gray600">
                <th className="py-3 px-4">Name</th>
                <th className="py-3 px-4">Days left</th>
                <th className="py-3 px-4">Renew</th>
                <th className="py-3 px-4">Auto-renew</th>
                <th className="py-3 px-4">Email address</th>
                <th className="py-3 px-4">Sessions</th>
                <th className="py-3 px-4">Status</th>
              </tr>
            </thead>
            <tbody>
              {students &&
                students.length > 0 &&
                students?.map((student) => (
                  <StudentCreditsManageTableRow
                    key={student?.id}
                    handleAutoRenewal={handleAutoRenewal}
                    handleUpgradeStudent={handleUpgradeStudent}
                    student={student}
                    user={user}
                    onOpenModal={handleOpenModal}
                  />
                ))}
            </tbody>
            <tfoot>
              <tr className="border-x-0 border-b-0 border-t border-gray200">
                <td className="py-3 px-4" colSpan="7">
                  <Pagination
                    currentPage={currentPage}
                    pageNumber={pageNumber}
                    onPageChange={onPageChange}
                  />
                </td>
              </tr>
            </tfoot>
          </table>
        </div>
      )}

      <ModalAutoRenew
        isOpen={isModalOpen}
        onClose={handleCloseModal}
        student={selectedStudent}
        user={user}
        initialModalStep={initialModalStep}
        handleUpgradeStudent={handleUpgradeStudent}
        handleAutoRenewal={handleAutoRenewal}
      />
    </>
  );
};

export default StudentCreditsManageTable;
